import { RequestHandler } from 'express';
import MigratortronBaseService from '~/services/MigratortronBaseService';
import { saveRecorded } from '../mockingMiddleware';
import mapAppErrorToObject from '~/transformations/mapAppErrorToObject';
import { MigrateRequest } from '~/models';
import WebhookMigrationService from '~/services/WebhookMigrationService';
import { isUndefined } from '~/util/typeguards';

export const getWebhooks: RequestHandler = async (req, res) => {
  try {
    const { id }: { id?: string } = res.locals;
    const {
      source: { webhooks },
    } = new MigratortronBaseService(res.locals.payload, res.locals.preview);

    if (id) await webhooks.GetSubscription(id);
    else await webhooks.GetSubscriptions();
    const response = webhooks.subscriptions;

    if (webhooks.error) throw webhooks.error;

    res.send(response);
    saveRecorded(req, res, {
      operation: 'getWebhooks',
      response,
    });
  } catch (error: any) {
    res.status(500).send({ error: mapAppErrorToObject(error) });
  }
};

export const migrateWebhooks: RequestHandler = async (req, res, next) => {
  try {
    const {
      payload,
      preview,
    }: {
      payload?: MigrateRequest;
      preview?: boolean;
    } = res.locals;

    const migrationService = new WebhookMigrationService(
      payload as MigrateRequest,
      preview !== false ? true : false
    );

    const results = await migrationService.MigrateWebhooks({
      enabled: !isUndefined(req.query.enabled)
        ? Boolean(req.query.enabled)
        : undefined,
    });

    const response = { committed: !preview, ...results };

    res.send(response);

    saveRecorded(req, res, {
      operation: 'migrateWebhooks',
      response,
    });

    res.locals.response = response;
  } catch (ex: any) {
    res.locals.response = { error: mapAppErrorToObject(ex) };
    res.setHeader('expose-raw-errors', 'true');
    res.status(500).send(res.locals.response);
  }
  next();
};
